export const DatePeriodFormControlName = {
  DatePeriod: 'datePeriod',
};

export const DatePeriodMode = {
  Full: 'full',
  Shorten: 'shorten',
  Shortest: 'shortest',
};

export const DatePeriodProperty = {
  DatePeriodMode: 'datePeriodMode',
};
